import {
	defaultWmsTransportDetailDto,
	WmsTransportDetailDto,
} from "src/dtos/wmsTransport/wmsTransportDto";
import {
	defaultTqcInspectResultDtlDto,
	defaultTqcInspectResultHdrDto,
	TqcInspectResultDtlDto,
	TqcInspectResultHdrDto,
} from "src/dtos/tqcInspectResult/tqcInspectResultDto";

/**
 * TQC1050_R01 그리드 행 DTO. 입고내역 1건 = 검사결과 1건.
 *
 * <p>화면의 네 검사항목은 상세 테이블의 inspectValue1_1~1_4 필드와 직접 대응한다.
 */
export interface TQC1050_R01Dto
	extends WmsTransportDetailDto, TqcInspectResultHdrDto, TqcInspectResultDtlDto {
	// 입고내역 조인 필드
	logicCenterNm: string;
	warehouseCd: string;
	warehouseNm: string;
	customCd: string;
	customNm: string;
	brandCd: string;
	brandNm: string;

	/** 판정 (OK / NG / '' = 미판정). 화면에서 직접 선택한다. */
	judgeResult: string;

}

export const defaultTQC1050_R01Dto: TQC1050_R01Dto = {
	...defaultWmsTransportDetailDto,
	...defaultTqcInspectResultHdrDto,
	...defaultTqcInspectResultDtlDto,
	logicCenterNm: '',
	warehouseCd: '',
	warehouseNm: '',
	customCd: '',
	customNm: '',
	brandCd: '',
	brandNm: '',

	judgeResult: '',
};

/** 판정 선택지. 빈 값은 미판정을 의미한다. */
export const TQC1050_R01_JUDGE_OPTIONS = ['OK', 'NG'];
